import { render, staticRenderFns } from "./imports-search-card.vue?vue&type=template&id=28193e00&scoped=true&"
import script from "./imports-search-card.vue?vue&type=script&lang=js&"
export * from "./imports-search-card.vue?vue&type=script&lang=js&"
import style0 from "./imports-search-card.vue?vue&type=style&index=0&id=28193e00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28193e00",
  null
  
)

export default component.exports